import gql from 'graphql-tag';

export default gql`
  mutation UploadDeliveryReceiptFromDispatchTrack(
    $input: UploadDeliveryReceiptFromDispatchTrackInput!
  ) {
    uploadDeliveryReceiptFromDispatchTrack(input: $input) {
      success
    }
  }
`;



// WEBPACK FOOTER //
// ./src/queries/uploadDeliveryReceiptFromDispatchTrack.js